import React, { useState } from "react";
import Header from "./Components/Header/Header.js";
import "./App.css";
import Input from "./Components/Input-component/Input.js";
import Renderlist from "./Components/Render-list/Renderlist.js";
function App() {
  let [todoList, updateTodoList] = useState([]);
  const [currentTodo, updateCurrentTodo] = useState("");

  const handleTodoList = () => {
    let tempTodoList = [...todoList];
    tempTodoList.push(currentTodo);
    updateTodoList(tempTodoList);
    updateCurrentTodo('');
  };

  const handleUpdateTodoList = (event) => {
    updateCurrentTodo(event.target.value);
    
  };

  const handleDeleteTodo = (item) => {
    // let updatedTodoList = [...todoList];
    todoList = todoList.filter((todoText) => todoText !== item);
    updateTodoList(todoList);
  };

  return (
    <div className="App">
      <Header></Header>
      <Input
        handleTodoList={handleTodoList}
        handleUpdateTodoList={handleUpdateTodoList}
        currValue={currentTodo}
      ></Input>
      <Renderlist
        todoList={todoList}
        handleDeleteTodo={handleDeleteTodo}
      ></Renderlist>
    </div>
  );
}
export default App;
